import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { projectsData } from '../data/projectsData';
export const Projects = () => {
  const [filter, setFilter] = useState('all');
  const filteredProjects = filter === 'all' ? projectsData : projectsData.filter(project => project.category === filter);
  return <section id="projects" className="py-20 bg-white dark:bg-gray-900 transition-colors" data-id="element-165">
      <div className="container mx-auto px-4 md:px-6" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-168">
            My Projects
          </h2>
          <div className="w-20 h-1 bg-indigo-600 dark:bg-indigo-400 mx-auto mb-6" data-id="element-169"></div>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-170">
            A selection of my recent work across various industries and
            platforms.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-10" data-id="element-171">
          <div className="flex flex-wrap gap-2 md:gap-4 justify-center relative" data-id="element-172">
            {['all', 'web', 'mobile', 'branding'].map(category => <motion.button key={category} onClick={() => setFilter(category)} className={`px-5 py-2 rounded-full capitalize transition-colors relative ${filter === category ? 'text-white' : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200'}`} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-173">
                {filter === category && <motion.div layoutId="activeFilter" className="absolute inset-0 bg-indigo-600 dark:bg-indigo-500 rounded-full" transition={{
              type: 'spring',
              bounce: 0.2,
              duration: 0.6
            }} data-id="element-174" />}
                <span className="relative z-10" data-id="element-175">
                  {category === 'all' ? 'All Projects' : `${category} Design`}
                </span>
              </motion.button>)}
          </div>
        </motion.div>

        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
          <AnimatePresence mode="popLayout" data-id="element-177">
            {filteredProjects.map((project, index) => <motion.div key={project.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4,
            delay: index * 0.1,
            layout: {
              duration: 0.4
            }
          }} data-id="element-178">
                <Link to={`/project/${project.id}`} className="group block bg-white dark:bg-gray-800 rounded-lg overflow-hidden shadow-md transition-colors" data-id="element-179">
                  <motion.div whileHover={{
                y: -8
              }} transition={{
                duration: 0.3,
                ease: 'easeOut'
              }} className="h-full" data-id="element-180">
                    <div className="relative overflow-hidden" data-id="element-181">
                      <motion.img src={project.image} alt={project.title} className="w-full h-64 object-cover" whileHover={{
                    scale: 1.05
                  }} transition={{
                    duration: 0.6,
                    ease: 'easeOut'
                  }} data-id="element-182" />
                      <motion.div initial={{
                    opacity: 0
                  }} whileHover={{
                    opacity: 1
                  }} transition={{
                    duration: 0.3
                  }} className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center" data-id="element-183">
                        <motion.div initial={{
                      y: 20,
                      opacity: 0
                    }} whileHover={{
                      y: 0,
                      opacity: 1
                    }} transition={{
                      duration: 0.3,
                      delay: 0.1
                    }} className="bg-white dark:bg-gray-800 text-indigo-600 dark:text-indigo-400 p-3 rounded-full" data-id="element-184">
                          <ExternalLink size={20} data-id="element-185" />
                        </motion.div>
                      </motion.div>
                    </div>
                    <div className="p-6" data-id="element-186">
                      <h3 className="text-xl font-bold mb-2 text-gray-900 dark:text-white" data-id="element-187">
                        {project.title}
                      </h3>
                      <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-188">
                        {project.description}
                      </p>
                      <div className="flex items-center" data-id="element-189">
                        <span className="text-xs uppercase tracking-wider bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-300 px-2 py-1 rounded" data-id="element-190">
                          {project.category === 'web' ? 'Web Design' : project.category === 'mobile' ? 'Mobile App' : 'Branding'}
                        </span>
                      </div>
                    </div>
                  </motion.div>
                </Link>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>;
};